

import { Link } from 'react-router-dom';
import { LogoSmall } from '@/components/Logo';
import { ProfileDropdown } from '@/components/ui/ProfileDropdown';

interface AppHeaderProps {
  displayName?: string;
  isAdmin?: boolean;
  showProfile?: boolean;
}

export function AppHeader({ displayName, isAdmin, showProfile = true }: AppHeaderProps) {
  return (
    <header className="border-b border-neutral-800">
      <div className="max-w-5xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Left spacer for centering */}
          <div className="w-10" />

          {/* Centered Logo */}
          <Link
            to="/games"
            className="hover:opacity-80 transition-opacity"
          >
            <LogoSmall />
          </Link>

          {/* Right side - Profile Dropdown */}
          <div className="w-10 flex justify-end">
            {showProfile && <ProfileDropdown displayName={displayName} isAdmin={isAdmin} />}
          </div>
        </div>
      </div>
    </header>
  );
}
